import { cn } from "@/lib/utils";
import { type ClassValue } from "clsx";

interface Props {
  readonly isColored?: boolean;
  readonly className?: ClassValue;
}

function EverbayLogo({ isColored = false, className }: Props) {
  return isColored ? (
    <svg
      aria-label="everbay"
      className={cn(className, "w-16")}
      shapeRendering="geometricPrecision"
      viewBox="0 0 171.133 141.853"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          gradientTransform="matrix(1283.5 0 0 -1283.5 0 531.942)"
          gradientUnits="userSpaceOnUse"
          id="b"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
        >
          <stop offset="0" stopColor="#2e4da7" />
          <stop offset="1" stopColor="#50c3a4" />
        </linearGradient>
        <clipPath clipPathUnits="userSpaceOnUse" id="a">
          <path d="m268.293 191.242 183.34 292.199 182.183-292.285Zm1000.617-41.855L724.031 1019.05a95.517 95.517 0 0 1-80.941 44.83h-.031c-32.887 0-63.461-16.92-80.942-44.77L14.613 146.508C-3.859 117.063-4.89 79.906 11.93 49.48A95.564 95.564 0 0 1 95.535.173L805.973 0h.019c34.707 0 66.692 18.832 83.547 49.172 16.844 30.363 15.918 67.473-2.453 96.933L585.883 629.348c-14.863 30.57-5.36 68.375 23.117 87.343 30.539 20.305 71.309 11.254 91.055-20.214l94.113-150.125c.145.027.293.078.437.105L1106.96 47.91c28.02-44.71 86.98-58.262 131.71-30.23 44.72 28.011 58.26 86.98 30.24 131.707z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)" transform="matrix(.13333 0 0 -.13333 0 141.853)">
        <path
          d="m268.293 191.242 183.34 292.199 182.183-292.285Zm1000.617-41.855L724.031 1019.05a95.517 95.517 0 0 1-80.941 44.83h-.031c-32.887 0-63.461-16.92-80.942-44.77L14.613 146.508C-3.859 117.063-4.89 79.906 11.93 49.48A95.564 95.564 0 0 1 95.535.173L805.973 0h.019c34.707 0 66.692 18.832 83.547 49.172 16.844 30.363 15.918 67.473-2.453 96.933L585.883 629.348c-14.863 30.57-5.36 68.375 23.117 87.343 30.539 20.305 71.309 11.254 91.055-20.214l94.113-150.125c.145.027.293.078.437.105L1106.96 47.91c28.02-44.71 86.98-58.262 131.71-30.23 44.72 28.011 58.26 86.98 30.24 131.707"
          fill="url(#b)"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ) : (
    <svg
      aria-label="everbay"
      className={cn(className)}
      fill="currentColor"
      height="53"
      viewBox="0 0 64 53"
      width="64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="matrix(0.498633,8.2173e-33,-8.2173e-33,-0.498633,-87.0658,174.273)">
        <path d="M238.915,349.502C235.626,349.502 232.569,347.811 230.821,345.026L176.071,257.764C174.223,254.821 174.12,251.104 175.802,248.062C177.484,245.02 180.687,243.132 184.162,243.131L255.207,243.114L255.208,243.114C258.68,243.114 261.878,244.997 263.563,248.031C265.248,251.068 265.154,254.778 263.318,257.725L233.197,306.049C231.711,309.106 232.662,312.887 235.509,314.783C238.563,316.814 242.64,315.909 244.615,312.762L254.026,297.749C254.041,297.752 254.056,297.757 254.07,297.76L285.305,247.906C288.107,243.434 294.004,242.079 298.476,244.882C302.948,247.684 304.303,253.58 301.501,258.052L247.013,345.02C245.266,347.808 242.208,349.501 238.919,349.502L238.915,349.502ZM201.439,262.238L219.773,291.458L237.991,262.229L201.439,262.238Z" />
      </g>
    </svg>
  );
}

export { EverbayLogo };
